import { BaseError } from './base';

export function NoActiveUserError(message, debug, code, kinveyRequestId) {
  this.name = 'NoActiveUserError';
  this.message = message || 'There is not an active user.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
NoActiveUserError.prototype = Object.create(BaseError.prototype);
NoActiveUserError.prototype.constructor = NoActiveUserError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/noActiveUser.js